import { useMemo } from "react";

import { useGetAppFormCompletionQuery, useGetOrgFormCompletionQuery } from "generated/graphql";

import { FormCompletion, toFormCompletion } from "./formCompletion";

export interface UseFormCompletionArgs {
    organizationId: string;
    /** Scope to one app; omit for the whole organization. */
    appId?: string;
    /** ISO 8601 */
    start: string;
    /** ISO 8601 */
    end: string;
    pause?: boolean;
}

/** Form completion rate for an app, or a whole organization, over a date range. */
export function useFormCompletion({ organizationId, appId, start, end, pause = false }: UseFormCompletionArgs): FormCompletion {
    const [app] = useGetAppFormCompletionQuery({
        requestPolicy: "cache-and-network",
        variables: { appId: appId || "", start, end },
        pause: pause || !appId,
    });
    const [org] = useGetOrgFormCompletionQuery({
        requestPolicy: "cache-and-network",
        variables: { organizationId, start, end },
        pause: pause || !!appId,
    });

    const result = appId ? app : org;
    const formAnalytics = appId ? app.data?.app?.formAnalytics : org.data?.org?.formAnalytics;
    const { loading, rate } = toFormCompletion({ fetching: result.fetching, error: result.error, overall: formAnalytics?.overall });
    // Stable between renders, so callers can keep it in a memo's dependencies.
    return useMemo(() => ({ loading, rate }), [loading, rate]);
}
